import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateFaqResponse } from '@ansvar-sakerhet/api-client';
import { useApi } from '../useApi';
import { clientKeys } from './clients.key';
import { toast } from '../../../components/Toast';

type Options = {
  onCreateQuestionSuccess?: (data: CreateFaqResponse) => void;
  onCreateQuestionError?: (error: unknown) => void;
};

export function useDeleteClient(options?: Options) {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const deleteClient = async (clientId: string) => {
    const api = await getApi();

    const res = await api.clientsDelete(clientId);

    return res.data;
  };

  const onSuccess = () => {
    toast.success('Client har tagits bort');
    queryClient.invalidateQueries({ queryKey: clientKeys.all });
  };

  const onError = (error: unknown) => {
    toast.error('Något gick fel');

    options?.onCreateQuestionError?.(error);
  };

  const mutation = useMutation(deleteClient, {
    onSuccess,
    onError,
  });

  return mutation;
}
